import axios from "axios";
import "./request_interceptor";

//const end_point1 = "http://192.168.30.225:88/api/finance_service/";
//const end_point1 = "https://preprodb.portailachats.ma/api/finance_service/";


const end_point1 = process.env.REACT_APP_API_URL + "/api/finance_service/";

////////////////////////////////////////////////////
//// bills
////////////////////////////////////////////////////

export const add_infos_toBill = async (data) => {
  return await axios.post(end_point1 + "add_infos_toBill", data);
};

export const count_bill = async (data) => {
  return await axios.post(end_point1 + "count_bill", data);
};

export const refuse_bill = async (data) => {
  return await axios.post(end_point1 + "refuse_bill", data);
};

export const getAll_financeService_market = async (
  id_financeServ,
  filterCategorie,
  searchFilter,
  searchValue,
  page
) => {
  return await axios.get(
    end_point1 +
      "getAll_financeService_market/" +
      id_financeServ +
      "/" +
      filterCategorie +
      "/" +
      searchFilter +
      "/" +
      searchValue +
      "?page=" +
      page
  );
};

export const getAll_financeService_orderBills = async(data,searchFilter,searchValue,page) => {
    return await axios.post(end_point1+'getAll_financeService_orderBills/'+searchFilter+'/'+searchValue+"?page="+page,data);
}

export const getAll_financeService_contract_bills = async(data,searchFilter,searchValue,page) => {
    return await axios.post(end_point1+'getAll_financeService_contract_bills/'+searchFilter+'/'+searchValue+"?page="+page,data);
}

export const notify_business_service_toView_bills = async (data) => {
  return await axios.post(
    end_point1 + "notify_business_service_toView_bills",
    data
  );
};

export const paye_bill = async (data) => {
  return await axios.post(end_point1 + "paye_bill", data);
};

export const archive_bill = async (data) => {
  return await axios.post(end_point1 + "archive_bill", data);
};

export const add_infos_torequest_order_Bill = async (data) => {
  return await axios.post(end_point1 + "add_infos_torequest_order_Bill", data);
};

export const add_infos_to_contract_Bill = async(data) => {
    return await axios.post(end_point1+'add_infos_to_contract_Bill',data);
}
export const count_request_order_bill = async(data) => {
    return await axios.post(end_point1+'count_request_order_bill',data);
}
export const count_contract_bill = async(data) => {
    return await axios.post(end_point1+'count_contract_bill',data);
}
export const refuse_request_order_bill = async(data) => {
    return await axios.post(end_point1+'refuse_request_order_bill',data);
}
export const refuse_contract_bill = async(data) => {
    return await axios.post(end_point1+'refuse_contract_bill',data);
}
 
export const notify_business_service_toView_request_order_bills = async(data)  => {
    return await axios.post(end_point1+'notify_business_service_toView_request_order_bills',data);
}

export const notify_purchase_service_toView_contract_bills = async(data)  => {
    return await axios.post(end_point1+'notify_purchase_service_toView_contract_bills',data);
}

export const paye_request_order_bill = async(data)  => {
    return await axios.post(end_point1+'paye_request_order_bill',data);
}
export const paye_contract_bill = async(data)  => {
    return await axios.post(end_point1+'paye_contract_bill',data);
}
export const archive_request_order_bill = async(data)  => {
    return await axios.post(end_point1+'archive_request_order_bill',data);
}
export const archive_contract_bill = async(data)  => {
    return await axios.post(end_point1+'archive_contract_bill',data);
}

////////////////////////////////////////////////////
//// MainWidget
////////////////////////////////////////////////////

export const billsWidget_by_finance = async (
  id,
  time_range,
  bills_src,
  filter
) => {
  return await axios.get(
    end_point1 +
      "billsWidget_by_finance/" +
      id +
      "/" +
      time_range +
      "/" +
      bills_src +
      "/" +
      filter
  );
};

export const charts_ofBillsAmount_payed_unpayed_byMonth = async (
  id,
  time_range
) => {
  return await axios.get(
    end_point1 +
      "charts_ofBillsAmount_payed_unpayed_byMonth/" +
      id +
      "/" +
      time_range
  );
};

export const delay_between_bills_expired_payed_dates = async (
  id,
  time_range,
  bills_src
) => {
  return await axios.get(
    end_point1 +
      "delay_between_bills_expired_payed_dates/" +
      id +
      "/" +
      time_range +
      "/" +
      bills_src
  );
};
